import store from '../store/Store'
import actionTypes from '../actionTypes/actionTypes'

async function setInputText(data) {
	const action = {
		type: actionTypes.SET_INPUT_TEXT,
		data
	};

	store.dispatch(action);
}

async function pageSwap(data) {
	const action = {
		type: actionTypes.PAGE_SWAP,
		data
	};

	store.dispatch(action);
}

async function pageRearrange(data) {
	const action = {
		type: actionTypes.PAGE_REARRANGE,
		data
	};

	store.dispatch(action);
}

async function addPage(data) {
	const action = {
		type: actionTypes.ADD_PAGE,
		data
	}

	store.dispatch(action)	
}

async function removePage(data) {
	const action = {
		type: actionTypes.REMOVE_PAGE,
		data
	}

	store.dispatch(action)	
}

async function changeSpacing(data) {
	const action = {
		type: actionTypes.CHANGE_SPACING,
		data
	};

	store.dispatch(action);
}

async function changeSpacingMargin(data) {
	const action = {
		type: actionTypes.CHANGE_SPACING_MARGIN,
		data
	};

	store.dispatch(action);
}

async function changeCurrentPage(data) {
	const action = {
		type: actionTypes.CHANGE_CURRENT_PAGE,
		data
	};

	store.dispatch(action);
}

async function changePreviousPage(data) {
	const action = {
		type: actionTypes.CHANGE_PREVIOUS_PAGE,
		data
	}

	store.dispatch(action)	
}

async function changeContextMenu(data) {
	const action = {
		type: actionTypes.CHANGE_CONTEXT_MENU,
		data
	};

	store.dispatch(action);
}

async function changeTextContextMenu(data) {
	const action = {
		type: actionTypes.CHANGE_TEXT_CONTEXT_MENU,
		data
	};

	store.dispatch(action);
}

async function setHeight(data) {
	const action = {
		type: actionTypes.SET_HEIGHT,
		data
	}

	store.dispatch(action)
}

async function setWidth(data) {
	const action = {
		type: actionTypes.SET_WIDTH,
		data
	}

	store.dispatch(action)
}

async function addMedia(data) {
	// console.log(data)

	const action = {
		type: actionTypes.ADD_MEDIA,
		data
	}

	store.dispatch(action)
}

async function updateMedia(data) {
	// console.log(data)
	
	const action = {
		type: actionTypes.UPDATE_MEDIA,
		data
	}

	store.dispatch(action)
}

async function removeMedia(data) {
	const action = {
		type: actionTypes.REMOVE_MEDIA,
		data
	}

	store.dispatch(action)
}

async function addSpan(data) {
	const action = {
		type: actionTypes.ADD_SPAN,
		data
	}

	store.dispatch(action)
}

async function removeSpan(data) {
	const action = {
		type: actionTypes.REMOVE_SPAN,
		data
	}

	store.dispatch(action)
}

async function addSkip(data) {
	const action = {
		type: actionTypes.ADD_SKIP,
		data
	}

	store.dispatch(action)
}

async function removeSkip(data) {
	const action = {
		type: actionTypes.REMOVE_SKIP,
		data
	}

	store.dispatch(action)
}

async function addBorderLeft(data) {
	const action = {
		type: actionTypes.ADD_BORDER_LEFT,
		data
	}

	store.dispatch(action)
}

async function removeBorderLeft(data) {
	const action = {
		type: actionTypes.REMOVE_BORDER_LEFT,
		data
	}

	store.dispatch(action)
}

async function addBorderTop(data) {
	const action = {
		type: actionTypes.ADD_BORDER_TOP,
		data
	}

	store.dispatch(action)
}

async function removeBorderTop(data) {
	const action = {
		type: actionTypes.REMOVE_BORDER_TOP,
		data
	}

	store.dispatch(action)
}

async function addBorderBottom(data) {
	const action = {
		type: actionTypes.ADD_BORDER_BOTTOM,
		data
	}

	store.dispatch(action)
}

async function removeBorderBottom(data) {
	const action = {
		type: actionTypes.REMOVE_BORDER_BOTTOM,
		data
	}

	store.dispatch(action)
}

async function addBorderRight(data) {
	const action = {
		type: actionTypes.ADD_BORDER_RIGHT,
		data
	}

	store.dispatch(action)
}

async function removeBorderRight(data) {
	const action = {
		type: actionTypes.REMOVE_BORDER_RIGHT,
		data
	}

	store.dispatch(action)
}

async function addBorder(data) {
	const action = {
		type: actionTypes.ADD_BORDER,
		data
	}

	store.dispatch(action)
}

async function removeBorder(data) {
	const action = {
		type: actionTypes.REMOVE_BORDER,
		data
	}

	store.dispatch(action)
}

async function increaseRows(data) {
	const action = {
		type: actionTypes.INCREASE_ROWS,
		data
	}

	store.dispatch(action)
}

async function decreaseRows() {
	const action = {
		type: actionTypes.DECREASE_ROWS
	}

	store.dispatch(action)
}

async function increaseColumns(data) {
	const action = {
		type: actionTypes.INCREASE_COLUMNS,
		data
	}

	store.dispatch(action)
}

async function decreaseColumns() {
	const action = {
		type: actionTypes.DECREASE_COLUMNS
	}

	store.dispatch(action)
}

async function addHoveredCell(data) {
	const action = {
		type: actionTypes.ADD_HOVERED_CELL,
		data
	}

	store.dispatch(action)
}

async function removeHoveredCell(data) {
	const action = {
		type: actionTypes.REMOVE_HOVERED_CELL,
		data
	}

	store.dispatch(action)
}

async function addEditCell(data) {
	const action = {
		type: actionTypes.ADD_EDIT_CELL,
		data
	}

	store.dispatch(action)
}

async function removeEditCell(data) {
	const action = {
		type: actionTypes.REMOVE_EDIT_CELL,
		data
	}

	store.dispatch(action)
}

async function addPreviewCell(data) {
	const action = {
		type: actionTypes.ADD_PREVIEW_CELL,
		data
	}

	store.dispatch(action)
}

async function removePreviewCell(data) {
	const action = {
		type: actionTypes.REMOVE_PREVIEW_CELL,
		data
	}

	store.dispatch(action)
}

async function addSelectedCell(data) {
	const action = {
		type: actionTypes.ADD_SELECTED_CELL,
		data
	}

	store.dispatch(action)
}

async function removeSelectedCell(data) {
	const action = {
		type: actionTypes.REMOVE_SELECTED_CELL,
		data
	}

	store.dispatch(action)
}

async function unselectSelectedCell(data) {
	const action = {
		type: actionTypes.UNSELECT_SELECTED_CELL,
		data
	}

	store.dispatch(action)
}

async function addSelectedColumn(data) {
	const action = {
		type: actionTypes.ADD_SELECTED_COLUMN,
		data
	}

	store.dispatch(action)
}

async function removeSelectedColumn(data) {
	const action = {
		type: actionTypes.REMOVE_SELECTED_COLUMN,
		data
	}

	store.dispatch(action)
}

async function deleteSelectedColumn(data) {
	const action = {
		type: actionTypes.DELETE_SELECTED_COLUMN,
		data
	}

	store.dispatch(action)
}

async function addSelectedRow(data) {
	const action = {
		type: actionTypes.ADD_SELECTED_ROW,
		data
	}

	store.dispatch(action)
}

async function removeSelectedRow(data) {
	const action = {
		type: actionTypes.REMOVE_SELECTED_ROW,
		data
	}

	store.dispatch(action)
}

async function deleteSelectedRow(data) {
	const action = {
		type: actionTypes.DELETE_SELECTED_ROW,
		data
	}

	store.dispatch(action)
}

async function changeTableNavigation(data) {
	const action = {
		type: actionTypes.CHANGE_TABLE_NAVIGATION,
		data
	}

	store.dispatch(action)	
}

async function changeTableNegativeNavigation(data) {
	const action = {
		type: actionTypes.CHANGE_TABLE_NEGATIVE_NAVIGATION,
		data
	}

	store.dispatch(action)	
}

async function changeTablePageSelection(data) {
	const action = {
		type: actionTypes.CHANGE_TABLE_PAGE_SELECTION,
		data
	}

	store.dispatch(action)	
}

async function changeTableNegativePageSelection(data) {
	const action = {
		type: actionTypes.CHANGE_TABLE_NEGATIVE_PAGE_SELECTION,
		data
	}

	store.dispatch(action)	
}

async function newTemplate() {
	const action = {
		type: actionTypes.NEW_TEMPLATE
	}

	store.dispatch(action)	
}

async function changePreview(data) {
	const action = {
		type: actionTypes.CHANGE_PREVIEW,
		data
	}

	store.dispatch(action)	
}

async function changeDetails(data) {
	const action = {
		type: actionTypes.CHANGE_DETAILS,
		data
	}

	store.dispatch(action)	
}

async function changeModal(data) {
	const action = {
		type: actionTypes.CHANGE_MODAL,
		data
	}

	store.dispatch(action)	
}

async function changeDetailsOrientation(data) {
	const action = {
		type: actionTypes.CHANGE_DETAILS_ORIENTATION,
		data
	}

	store.dispatch(action)	
}

const articleActions = {
	/* PAGE */
	addPage,
	changeCurrentPage,
	changePreviousPage,
	removePage,

	/* INPUT TEXT */
	setInputText,

	/* SWAP */
	pageSwap,

	/* REARRANGE */
	pageRearrange,

	/* MEDIA */
	addMedia,
	updateMedia,
	removeMedia,

	/* CONTEXT MENU */
	changeContextMenu,
	changeTextContextMenu,

	/* EDIT */
	addEditCell,
	removeEditCell,

	/* PREVIEW */
	addPreviewCell,
	removePreviewCell,

	/* SPACING */
	changeSpacing,
	changeSpacingMargin,

	/* MODAL */
	changeModal,
	
	/* WIDTH */
	setWidth,

	/* HEIGHT */
	setHeight,

	/* DETAILS */
	changeDetails,
	changeDetailsOrientation,

	/* TEMPLATE */
	newTemplate,

	/* PREVIEW */
	changePreview,

	/* SPAN */
	addSpan,
	removeSpan,

	/* SKIP */
	addSkip,
	removeSkip,

	/* COLUMN */
	addSelectedColumn,
	removeSelectedColumn,
	deleteSelectedColumn,

	/* ROW */
	addSelectedRow,
	removeSelectedRow,
	deleteSelectedRow,

	/* BORDER */
	addBorderLeft,
	removeBorderLeft,
	addBorderRight,
	removeBorderRight,
	addBorderTop,
	removeBorderTop,
	addBorderBottom,
	removeBorderBottom,
	addBorder,
	removeBorder,

	/* END BORDER */
	increaseRows,
	decreaseRows,
	increaseColumns,
	decreaseColumns,
	addSelectedCell,
	removeSelectedCell,
	addHoveredCell,
	removeHoveredCell,
	unselectSelectedCell,
	changeTableNavigation,
	changeTableNegativeNavigation,
	changeTablePageSelection,
	changeTableNegativePageSelection
}

export default articleActions